import PGSHelper from "../../helpers/PGSHelper.js";
let pgsHelper = new PGSHelper();
export default class ReporteZ {
  monedaDefault = "";
  totalSistema = 0;
  totalSistemaOtros = 0;
  subTotalProductos = 0;
  taxProductos = 0;
  totalPropinas = 0;
  totalPropinasOtros = 0;
  constructor() { }

  getDocData(contadores, familias, mPagos, mainData, descuentos, totalesArea) {

    let otrosTable = this.getOtrosTable(contadores, mPagos);
    let totalesAreaTable = this.getTotalesArea(totalesArea);
    let tenderTable = this.getTenderTable(contadores, mPagos);
    let familiasTable = this.getFamiliasTable(familias);
    let aybTable = this.getAYBTotales(familias);
    let descuentosTable = this.getDescuentosTable(descuentos);
    //let otrosTable = this.getOtrosTable(contadores, mPagos)
    let descBody = {
      // % width
      width: "50%",
      table: {
        widths: ["*"],
        heights: 100,
        body: [[{ text: "", bold: true, alignment: "center" }]],
      },
    };
    if (mainData.Tenant == "BOKA") {
      descBody = {
        width: "50%",
        table: {
          heights: 100,
          widths: ["*"],
          body: [[descuentosTable]],
        },
      };
    }
    let docDefinition = {
      pageMargins: [20, 20, 20, 20],
      content: [
        //header
        {
          columns: [
            {
              // star-sized columns fill the remaining space
              // if there's more than one star-column, available width is divided equally
              width: "25%",
              text: "",
            },
            {
              // fixed width
              width: "50%",
              alignment: "center",
              bold: true,
              text: [
                mainData.TITLE + "\n",
                mainData.DeptoName + "\n",
                mainData.Caja + "\n",
                mainData.Cajero + "\n",
                "Del " + mainData.FI + " a " + mainData.FF + "\n",
              ],
            },
            {
              // % width
              width: "25%",
              bold: true,
              text: [
                "Generado: " + mainData.FG + "\n",
                "Hora: " + mainData.HG + "\n",
                "Turno: " + mainData.Turno + "\n",
              ],
            },
          ],
          // optional space between columns
          columnGap: 10,
        },
        //columns tender-revenue
        {
          columns: [
            {
              // fixed width
              width: "50%",
              table: {
                widths: ["*"],
                headerRows: 1,
                body: [
                  [
                    {
                      text: "Metodos de pago",
                      bold: true,
                      border: [true, true, true, true],
                      heights: 200,
                      alignment: "center",
                    },
                  ],
                ],
              },
            },
            {
              // % width
              width: "50%",
              table: {
                widths: ["*"],
                body: [[{ text: "Familias", bold: true, alignment: "center" }]],
              },
            },
          ],
          margin: [0, 20, 0, 0],
        },
        {
          columns: [
            {
              // fixed width
              width: "50%",
              table: {
                heights: 300,
                widths: ["*"],
                body: [[tenderTable]],
              },
            },
            {
              // % width
              width: "50%",
              table: {
                widths: ["*"],
                heights: 300,
                body: [[familiasTable]],
              },
            },
          ],
          margin: [0, 0, 0, 0],
        },
        {
          columns: [
            descBody,
            {
              // % width
              width: "50%",
              table: {
                widths: ["*"],
                heights: 100,
                body: [[{
                  table: {
                    widths: [155, 65],
                    body: [
                      [
                        {
                          text: (mainData.Tenant == "BOKA") ? "Clientes: " + mainData.Comensales : "",
                          fontSize: 10,
                          border: [false, false, false, false],
                        },
                      ],
                    ],
                  },

                },]],
              },
            },
          ],
          margin: [0, 0, 0, 0],
        },
        {
          columns: [
            {
              // % width
              width: "50%",
              table: {
                widths: ["*"],
                heights: 50,
                body: [
                  [
                    {
                      table: {
                        widths: [155, 65],
                        body: [
                          [
                            {
                              text: "+ Metodos Pago",
                              border: [false, false, false, false],
                              fontSize: 10,
                            },
                            {
                              text: pgsHelper.formatNumber(this.totalSistema),
                              border: [false, false, false, false],
                              fontSize: 10,
                              alignment: "right",
                            },
                          ],

                          [
                            {
                              text: " - Propinas",
                              border: [false, false, false, false],
                              fontSize: 10,
                            },
                            {
                              text: pgsHelper.formatNumber(this.totalPropinas),
                              border: [false, false, false, false],
                              fontSize: 10,
                              alignment: "right",
                            },
                          ],
                        ],
                      },
                      border: [true, true, false, false],
                    },
                  ],
                ],
              },
            },
            {
              // % width
              width: "50%",
              table: {
                widths: ["*"],
                heights: 50,
                body: [
                  [
                    {
                      table: {
                        widths: [155, 65],
                        body: [
                          [
                            {
                              text: "Productos",
                              border: [false, false, false, false],
                              fontSize: 10,
                            },
                            {
                              text: pgsHelper.formatNumber(
                                this.subTotalProductos
                              ),
                              border: [false, false, false, false],
                              fontSize: 10,
                              alignment: "right",
                            },
                          ],
                          [
                            {
                              text: "Impuestos",
                              border: [false, false, false, false],
                              fontSize: 10,
                            },
                            {
                              text: pgsHelper.formatNumber(this.taxProductos),
                              border: [false, false, false, false],
                              fontSize: 10,
                              alignment: "right",
                            },
                          ],
                        ],
                      },
                      border: [false, true, true, false],
                    },
                  ],
                ],
              },
            },
          ],
          margin: [0, 0, 0, 0],
        },
        {
          columns: [
            {
              // % width
              width: "50%",
              table: {
                widths: ["*"],

                body: [
                  [
                    {
                      table: {
                        widths: [155, 65],
                        body: [
                          [
                            {
                              text: "Total",
                              border: [false, false, false, false],
                              bold: true,
                              fontSize: 10,
                            },
                            {
                              text: pgsHelper.formatNumber(
                                this.totalSistema - this.totalPropinas
                              ),
                              bold: true,
                              border: [false, true, false, false],
                              fontSize: 10,
                              alignment: "right",
                            },
                          ],
                        ],
                      },
                      border: [true, false, false, true],
                    },
                  ],
                ],
              },
            },
            {
              // % width
              width: "50%",
              table: {
                widths: ["*"],

                body: [
                  [
                    {
                      table: {
                        widths: [155, 65],
                        body: [
                          [
                            {
                              text: "Total",
                              border: [false, false, false, false],
                              bold: true,
                              fontSize: 10,
                            },
                            {
                              text: pgsHelper.formatNumber(
                                this.subTotalProductos + this.taxProductos
                              ),
                              bold: true,
                              border: [false, true, false, false],
                              fontSize: 10,
                              alignment: "right",
                            },
                          ],
                        ],
                      },
                      border: [false, false, true, true],
                    },
                  ],
                ],
              },
            },
          ],
          margin: [0, 0, 0, 0],
        },
      ],
    };
    if (mainData.DetailedData) {
      docDefinition.content.push({
        table: {
          widths: ["*", "*"],
          layout: 'noBorders',
          border: [false, false, false, false],
          body: [
            [
              {
                text: `De: ${mainData.FI}\nHasta: ${mainData.FF}`,
                border: [false, false, false, false],
                bold: true,
              },
              {
                text: `Generado: ${mainData.FG}\nHora: ${mainData.HG}`,
                border: [false, false, false, false],
                alignment: "right",
                bold: true,
              },
            ],
          ],
        },
        pageBreak: "before",
        margin: [0, 0, 0, 10],
      })
      docDefinition.content.push({
        text: "Totales por area",
        bold: true,
        fontSize: 12,
        margin: [0, 0, 0, 10],
      })
      docDefinition.content.push({
        table: {
          layout: 'noBorders',
          border: [false, false, false, false],
          widths: ["*"],
          body: [[totalesAreaTable]],
        },
      })
      docDefinition.content.push({
        text: "Totales AYB",
        bold: true,
        fontSize: 12,
        margin: [0, 10, 0, 10],
      })
      docDefinition.content.push({
        table: {
          layout: 'noBorders',
          border: [false, false, false, false],
          widths: ["*"],
          body: [[aybTable]],
        },
      })
    }
    return docDefinition;
  }

  getTenderTable(contadores, mPagos) {
    let conts = Object.entries(contadores.dataTotalsSystem);
    //dataPropinas
    let contsSort = conts.sort(function (a, b) {
      if (a[0] > b[0]) {
        return 1;
      }
      if (b[0] > a[0]) {
        return -1;
      }
      return 0;
    });

    let listMoney = [
      [
        {
          text: "Metodo de pago",
          border: [false, false, false, true],
          fontSize: 7,
        },
        {
          text: "Sistema",
          border: [false, false, false, true],
          fontSize: 7,
          alignment: "right",
        },
        {
          text: "Propina",
          border: [false, false, false, true],
          fontSize: 7,
          alignment: "right",
        },
        {
          text: "Total",
          border: [false, false, false, true],
          fontSize: 7,
          alignment: "right",
        },
        {
          text: "Contador",
          border: [false, false, false, true],
          fontSize: 7,
          alignment: "right",
        },
      ],
    ];
    let totalSys = 0;
    let totalCon = 0;
    let totalNeto = 0;
    let totalPropinas = 0;
    let totalEfectivoMXN = 0;
    contsSort.forEach((cont) => {
      if (cont[1] == 0 && contadores.dataTotals[cont[0]] == 0 && (!contadores.dataPropinas[cont[0]] || contadores.dataPropinas[cont[0]] == 0)) {
        console.log("no");
      } else {
        if (
          cont[0] != "Cambio" &&
          (cont[0] != "VISA_MXN") &
          (cont[0] != "MACA_MXN") &
          (cont[0] != "MACA_USD") &
          (cont[0] != "VISA_USD") &
          (cont[0] != "MACA_USD_CONV") &
          (cont[0] != "VISA_USD_CONV") &
          (cont[0] != "CNTA")
        ) {
          if (cont[0] == "MNDR_MXN") {
            contadores.dataTotals[cont[0]] =
              cont[1] +
              (contadores.dataPropinas[cont[0]]
                ? contadores.dataPropinas[cont[0]]
                : 0);
          }
          let splitPago = cont[0].split("_");
          if (splitPago[1] == "MXN" || cont[0] == "Tarjetas" || cont[0] == "TarjetasUSD_CONV") {
            totalSys =
              totalSys +
              (cont[1] +
                (contadores.dataPropinas[cont[0]]
                  ? contadores.dataPropinas[cont[0]]
                  : 0));
            totalNeto = totalNeto + cont[1];
            totalCon =
              totalCon +
              (contadores.dataTotals[cont[0]]
                ? contadores.dataTotals[cont[0]]
                : 0);
            totalPropinas =
              totalPropinas +
              (contadores.dataPropinas[cont[0]]
                ? contadores.dataPropinas[cont[0]]
                : 0);
          } else if (splitPago[2]) {
            if (splitPago[2] == "CONV") {
              totalSys =
                totalSys +
                (cont[1] +
                  (contadores.dataPropinas[cont[0]]
                    ? contadores.dataPropinas[cont[0]]
                    : 0));
              totalCon = totalCon + contadores.dataTotals[cont[0]];
              totalNeto = totalNeto + cont[1];
              totalPropinas =
                totalPropinas +
                (contadores.dataPropinas[cont[0]]
                  ? contadores.dataPropinas[cont[0]]
                  : 0);
            }
          }

          if (cont[0] == "EFVO_MXN") {
            totalEfectivoMXN =
              cont[1] +
              (contadores.dataPropinas[cont[0]]
                ? contadores.dataPropinas[cont[0]]
                : 0);
          }

          listMoney.push([
            {
              text: this.getPagoName(mPagos, cont[0]),
              border: [false, false, false, false],
              fontSize: 7,
            },
            {
              text: pgsHelper.formatNumber(cont[1]),
              border: [false, false, false, false],
              fontSize: 7,
              alignment: "right",
            },
            {
              text: pgsHelper.formatNumber(
                contadores.dataPropinas[cont[0]]
                  ? contadores.dataPropinas[cont[0]]
                  : 0
              ),
              border: [false, false, false, false],
              fontSize: 7,
              alignment: "right",
            },
            {
              text: pgsHelper.formatNumber(
                cont[1] +
                (contadores.dataPropinas[cont[0]]
                  ? contadores.dataPropinas[cont[0]]
                  : 0)
              ),
              border: [false, false, false, false],
              fontSize: 7,
              alignment: "right",
            },
            {
              text: pgsHelper.formatNumber(
                contadores.dataTotals[cont[0]]
                  ? contadores.dataTotals[cont[0]]
                  : 0
              ),
              border: [false, false, false, false],
              fontSize: 7,
              alignment: "right",
            },
          ]);
        }
      }
    });
    this.totalSistema = totalCon;
    this.totalPropinas = totalPropinas;
    listMoney.push([
      { text: "TOTAL", border: [false, false, false, false], fontSize: 7 },
      {
        text: pgsHelper.formatNumber(totalNeto),
        border: [false, true, false, false],
        fontSize: 7,
        alignment: "right",
      },
      {
        text: pgsHelper.formatNumber(totalPropinas),
        border: [false, true, false, false],
        fontSize: 7,
        alignment: "right",
      },
      {
        text: pgsHelper.formatNumber(totalSys),
        border: [false, true, false, false],
        fontSize: 7,
        alignment: "right",
      },
      {
        text: pgsHelper.formatNumber(totalCon),
        border: [false, true, false, false],
        fontSize: 7,
        alignment: "right",
      },
    ]);
    listMoney.push([
      { text: "DIFERENCIA", border: [false, false, false, false], fontSize: 7 },
      {
        text: "",
        border: [false, false, false, false],
        fontSize: 7,
        alignment: "right",
      },
      {
        text: "",
        border: [false, false, false, false],
        fontSize: 7,
        alignment: "right",
      },
      {
        text: pgsHelper.formatNumber(totalSys - totalCon),
        border: [false, false, false, false],
        fontSize: 7,
        alignment: "right",
      },
      {
        text: "",
        border: [false, false, false, false],
        fontSize: 8,
        alignment: "right",
      },
    ]);
    listMoney.push([
      { text: "", border: [false, false, false, false], fontSize: 7 },
      {
        text: "",
        border: [false, false, false, false],
        fontSize: 7,
        alignment: "right",
      },
      {
        text: "",
        border: [false, false, false, false],
        fontSize: 7,
        alignment: "right",
      },
      {
        text: "",
        border: [false, false, false, false],
        fontSize: 7,
        alignment: "right",
      },
      {
        text: "",
        border: [false, false, false, false],
        fontSize: 7,
        alignment: "right",
      },
    ]);
    listMoney.push([
      {
        text: "EFECTIVO MENOS PROPINA",
        border: [false, false, false, false],
        fontSize: 7,
      },
      {
        text: "",
        border: [false, false, false, false],
        fontSize: 7,
        alignment: "right",
      },
      {
        text: "",
        border: [false, false, false, false],
        fontSize: 7,
        alignment: "right",
      },
      {
        text: pgsHelper.formatNumber(totalEfectivoMXN - totalPropinas),
        border: [false, false, false, false],
        fontSize: 7,
        alignment: "right",
      },
      {
        text: "",
        border: [false, false, false, false],
        fontSize: 7,
        alignment: "right",
      },
    ]);
    if (contadores.dataTotalsSystem["CNTA"] > 0) {
      listMoney.push([
        {
          text: "CUENTAS POR COBRAR",
          border: [false, false, false, false],
          fontSize: 7,
        },
        {
          text: "",
          border: [false, false, false, false],
          fontSize: 7,
          alignment: "right",
        },
        {
          text: "",
          border: [false, false, false, false],
          fontSize: 7,
          alignment: "right",
        },
        {
          text: contadores.dataTotalsSystem["CNTA"],
          border: [false, false, false, false],
          fontSize: 7,
          alignment: "right",
        },
        {
          text: "",
          border: [false, false, false, false],
          fontSize: 7,
          alignment: "right",
        },
      ]);
    }

    let table = {
      border: [true, false, true, true],
      table: {
        widths: [60, 40, 40, 40, 40],
        body: listMoney,
      },
    };
    return table;
  }
  getDescuentosTable(descuentos) {
    let cantidadTotal = 0
    let totalDescuentos = 0
    let list = [
      [
        {
          text: "Descuentos",
          border: [false, false, false, true],
          fontSize: 10,
        },
        {
          text: "Cnt",
          border: [false, false, false, true],
          fontSize: 10,
          alignment: "right",
        },
        {
          text: "Total",
          border: [false, false, false, true],
          fontSize: 10,
          alignment: "right",
        },
      ],
    ];
    descuentos.forEach((desc) => {
      cantidadTotal += desc.Cnt
      totalDescuentos += desc.Ttl
      list.push([
        {
          text: desc.Desc,
          border: [false, false, false, false],
          fontSize: 8,
        },
        {
          text: pgsHelper.formatNumber(desc.Cnt),
          border: [false, false, false, false],
          fontSize: 8,
          alignment: "right",
        },
        {
          text: pgsHelper.formatNumber(desc.Ttl),
          border: [false, false, false, false],
          fontSize: 8,
          alignment: "right",
        },
      ]);
    })

    list.push([
      {
        text: "TOTAL",
        border: [false, true, false, false],
        fontSize: 8,
      },
      {
        text: pgsHelper.formatNumber(cantidadTotal),
        border: [false, true, false, false],
        fontSize: 8,
        alignment: "right",
      },
      {
        text: pgsHelper.formatNumber(totalDescuentos),
        border: [false, true, false, false],
        fontSize: 8,
        alignment: "right",
      },
    ]);

    let table = {
      border: [true, false, true, true],
      table: {
        widths: [100, 35, 100],
        body: list,
      },
    };
    return table;
  }
  getOtrosTable(contadores, mPagos) {
    let conts = Object.entries(contadores.dataTotalsSystem);
    let contsSort = conts.sort(function (a, b) {
      if (a[0] > b[0]) {
        return 1;
      }
      if (b[0] > a[0]) {
        return -1;
      }
      return 0;
    });
    let list = [
      [
        {
          text: "Descripción",
          border: [false, false, false, true],
          fontSize: 10,
        },
        {
          text: "Sistema",
          border: [false, false, false, true],
          fontSize: 10,
          alignment: "right",
        },
      ],
    ];
    let totalSys = 0;
    contsSort.forEach((cont) => {
      if (cont[1] == 0 && contadores.dataTotals[cont[0]] == 0) {
        console.log("no");
      } else {
        if (cont[0] == "MNDR_MXN") {
          let splitPago = cont[0].split("_");
          if (splitPago[1] == "MXN" || cont[0] == "Tarjetas") {
            totalSys = totalSys + cont[1];
          } else if (splitPago[2]) {
            if (splitPago[2] == "CONV") {
              totalSys = totalSys + cont[1];
            }
          }

          this.totalPropinasOtros = contadores.dataPropinas[cont[0]]
            ? contadores.dataPropinas[cont[0]]
            : 0;
          list.push([
            {
              text: this.getPagoName(mPagos, cont[0]),
              border: [false, false, false, false],
              fontSize: 10,
            },
            {
              text: pgsHelper.formatNumber(cont[1]),
              border: [false, false, false, false],
              fontSize: 10,
              alignment: "right",
            },
          ]);
          list.push([
            {
              text: "PROPINA MONEDERO",
              border: [false, false, false, false],
              fontSize: 10,
            },
            {
              text: pgsHelper.formatNumber(
                contadores.dataPropinas[cont[0]]
                  ? contadores.dataPropinas[cont[0]]
                  : 0
              ),
              border: [false, false, false, false],
              fontSize: 10,
              alignment: "right",
            },
          ]);
        }
      }
    });
    this.totalSistemaOtros = totalSys;
    list.push([
      { text: "TOTAL", border: [false, false, false, false], fontSize: 10 },
      {
        text: pgsHelper.formatNumber(totalSys),
        border: [false, true, false, false],
        fontSize: 10,
        alignment: "right",
      },
    ]);
    let table = {
      border: [true, false, true, true],
      table: {
        widths: [155, 65],
        body: list,
      },
    };
    return table;
  }
  getFamiliasTable(familias) {
    let listFam = [
      [
        { text: "Familia", border: [false, false, false, true], fontSize: 8 },
        {
          text: "Q",
          border: [false, false, false, true],
          fontSize: 8,
          alignment: "right",
        },
        {
          text: "Subtotal",
          border: [false, false, false, true],
          fontSize: 8,
          alignment: "right",
        },
        {
          text: "IVA",
          border: [false, false, false, true],
          fontSize: 8,
          alignment: "right",
        },
        {
          text: "Total",
          border: [false, false, false, true],
          fontSize: 8,
          alignment: "right",
        },
        {
          text: "%",
          border: [false, false, false, true],
          fontSize: 8,
          alignment: "right",
        },
      ],
    ];
    let totalCant = 0;
    let totalSub = 0;
    let totalImpuestos = 0;
    let conts = Object.entries(familias);
    let contsSort = conts.sort(function (a, b) {
      if (a[1].Nombre > b[1].Nombre) {
        return 1;
      }
      if (b[1].Nombre > a[1].Nombre) {
        return -1;
      }
      return 0;
    });
    contsSort.forEach((cont) => {
      totalCant = totalCant + cont[1].Cantidad;
      totalSub = totalSub + cont[1].Subtotal;
      totalImpuestos = totalImpuestos + cont[1].Impuestos;
      listFam.push([
        {
          text: cont[1].Nombre.toUpperCase(),
          border: [false, false, false, false],
          fontSize: 7,
        },
        {
          text: pgsHelper.formatNumber(cont[1].Cantidad),
          border: [false, false, false, false],
          fontSize: 7,
          alignment: "right",
        },
        {
          text: pgsHelper.formatNumber(cont[1].Subtotal),
          border: [false, false, false, false],
          fontSize: 7,
          alignment: "right",
        },
        {
          text: pgsHelper.formatNumber(cont[1].Impuestos),
          border: [false, false, false, false],
          fontSize: 7,
          alignment: "right",
        },
        {
          text: pgsHelper.formatNumber(cont[1].Subtotal + cont[1].Impuestos),
          border: [false, false, false, false],
          fontSize: 7,
          alignment: "right",
        },
        {
          text: pgsHelper.formatNumber(cont[1].Iva) + "%",
          border: [false, false, false, false],
          fontSize: 7,
          alignment: "right",
        },
      ]);
    });
    this.subTotalProductos = totalSub;
    this.taxProductos = totalImpuestos;
    /*listFam.push(
      [
        { text: "SUBTOTAL", border: [false, false, false, false], fontSize: 8 },
        { text: "", border: [false, true, false, false], fontSize: 8, alignment: 'right' },
        { text: pgsHelper.formatNumber(totalSub), border: [false, true, false, false], fontSize: 8, alignment: 'right' },
        { text: pgsHelper.formatNumber(totalSub), border: [false, true, false, false], fontSize: 8, alignment: 'right' },
        { text: pgsHelper.formatNumber(totalSub), border: [false, true, false, false], fontSize: 8, alignment: 'right' },

      ]
    )
    listFam.push(
      [
        { text: "IMPUESTOS", border: [false, false, false, false], fontSize: 10 },
        { text: "", border: [false, false, false, false], fontSize: 10, alignment: 'right' },
        { text: pgsHelper.formatNumber(totalImpuestos), border: [false, false, false, false], fontSize: 10, alignment: 'right' },
        { text: pgsHelper.formatNumber(totalSub), border: [false, true, false, false], fontSize: 10, alignment: 'right' },

        { text: pgsHelper.formatNumber(totalSub), border: [false, true, false, false], fontSize: 10, alignment: 'right' },

      ]
    )*/
    listFam.push([
      { text: "TOTAL", border: [false, false, false, false], fontSize: 7 },
      {
        text: "",
        border: [false, false, false, false],
        fontSize: 7,
        alignment: "right",
      },
      {
        text: pgsHelper.formatNumber(totalSub),
        border: [false, true, false, false],
        fontSize: 7,
        alignment: "right",
      },
      {
        text: pgsHelper.formatNumber(totalImpuestos),
        border: [false, true, false, false],
        fontSize: 7,
        alignment: "right",
      },
      {
        text: pgsHelper.formatNumber(totalSub + totalImpuestos),
        border: [false, true, false, false],
        fontSize: 7,
        alignment: "right",
      },
      {
        text: "",
        border: [false, true, false, false],
        fontSize: 7,
        alignment: "right",
      },
    ]);

    let table = {
      border: [true, false, true, true],
      table: {
        widths: [75, 15, 35, 35, 35, 15],
        body: listFam,
      },
    };
    return table;
  }
  getTotalesArea(totalesArea) {
    const totales = pgsHelper.ArrayObjectToArray(totalesArea)
    let listFam = [];
    const totalesGenerales = totales.reduce((acc, item) => {
      acc.Ventas += item.Ventas;
      acc.Comensales += item.Comensales;
      acc.Total += item.Total;
      return acc;
    }, { Ventas: 0, Comensales: 0, Total: 0 });
    listFam.push([
      { text: "AREA", border: [false, false, false, false], fontSize: 10 },
      {
        text: "VENTAS",
        border: [false, false, false, false],
        fontSize: 10,
        alignment: "right",
      },
      {
        text: "COMENSALES",
        border: [false, false, false, false],
        fontSize: 10,
        alignment: "right",
      },
      {
        text: "TOTAL",
        border: [false, false, false, false],
        fontSize: 10,
        alignment: "right",
      },
    ]);
    totales.forEach((item) => {
      listFam.push([
        { text: item.Nombre, border: [false, true, false, false], fontSize: 10 },
        {
          text: pgsHelper.formatNumber(item.Ventas),
          border: [false, true, false, false],
          fontSize: 10,
          alignment: "right",
        },
        {
          text: pgsHelper.formatNumber(item.Comensales),
          border: [false, true, false, false],
          fontSize: 10,
          alignment: "right",
        },
        {
          text: pgsHelper.formatNumber(item.Total),
          border: [false, true, false, false],
          fontSize: 10,
          alignment: "right",
        },

      ]);
    });
    listFam.push([
      { text: "TOTALES GENERALES", border: [false, true, false, false], fontSize: 10 },
      {
        text: pgsHelper.formatNumber(totalesGenerales.Ventas),
        border: [false, true, false, false],
        fontSize: 10,
        bold: true,
        alignment: "right",
      },
      {
        text: pgsHelper.formatNumber(totalesGenerales.Comensales),
        border: [false, true, false, false],
        fontSize: 10,
        bold: true,
        alignment: "right",
      },
      {
        text: pgsHelper.formatNumber(totalesGenerales.Total),
        border: [false, true, false, false],
        fontSize: 10,
        bold: true,
        alignment: "right",
      },

    ]);

    let table = {
      border: [false, false, false, false],
      table: {
        widths: "*",
        body: listFam,
      },
    };
    return table;
  }
  getAYBTotales(familias) {
    let listFam = [
      [
        { text: "TIPO", border: [false, false, false, true], fontSize: 8 },
        {
          text: "TOTAL",
          border: [false, false, false, true],
          fontSize: 8,
          alignment: "right",
        },
      ],
    ];

    let groupedTotals = {
      "ALIMENTOS": 0,
      "BEBIDAS": 0,
      "OTROS": 0
    };

    Object.values(familias).forEach((item) => {
      const nombre = (item.Nombre || "").toUpperCase();
      const total = (item.Subtotal || 0) + (item.Impuestos || 0);
      if (nombre.includes("ALIMENTOS")) {
        groupedTotals["ALIMENTOS"] += total;
      } else if (nombre.includes("BEBIDAS")) {
        groupedTotals["BEBIDAS"] += total;
      } else {
        groupedTotals["OTROS"] += total;
      }
    });

    const sortedGroups = Object.entries(groupedTotals)
      .filter(([_, total]) => total > 0)
      .sort((a, b) => a[0].localeCompare(b[0]));

    sortedGroups.forEach(([tipo, total]) => {
      listFam.push([
        { text: tipo, border: [false, true, false, false], fontSize: 10 },
        {
          text: pgsHelper.formatNumber(total),
          border: [false, true, false, false],
          fontSize: 10,
          alignment: "right",
        },
      ]);
    });

    let table = {
      border: [false, false, false, false],
      table: {
        widths: "*",
        body: listFam,
      },
    };
    return table;
  }
  getPagoName(list, pago) {
    if (pago == "Tarjetas") {
      return "VISA/MC MXN";
    } else if (pago == "TarjetasUSD") {
      return "VISA/MC USD";
    } else if (pago == "TarjetasUSD_CONV") {
      return "VISA/MC USD CONV";
    } else {
      let splitPago = pago.split("_");
      let pagoMpago = pgsHelper.getById(list, "id", splitPago[0]);
      if (splitPago[2]) {
        return pagoMpago.id + " " + splitPago[1] + " CONV";
      }
      return pagoMpago.id + " " + splitPago[1];
    }
  }
}
